class StorefrontBrandSwitcher extends HTMLElement {
  connectedCallback() {
    this.listeners?.abort();
    this.listeners = new AbortController();
    const { signal } = this.listeners;
    this.buttons = Array.from(this.querySelectorAll('[data-brand-switch-button]:not(:disabled)'));
    this.panels = Array.from(this.querySelectorAll('[data-brand-switch-panel]'));
    this.index = 0;
    this.timer = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.select(button.dataset.brandSwitchButton);
        this.restartAutoplay();
      }, { signal });
    });

    this.panels.forEach((panel) => {
      panel.hidden = false;
      panel.setAttribute('aria-hidden', panel.dataset.active === 'true' ? 'false' : 'true');
    });

    const activeButton = this.buttons.find((button) => button.getAttribute('aria-pressed') === 'true') || this.buttons[0];

    if (activeButton) {
      this.select(activeButton.dataset.brandSwitchButton, false);
    }

    this.addEventListener('pointerenter', () => this.stopAutoplay(), { signal });
    this.addEventListener('pointerleave', () => this.startAutoplay(), { signal });
    this.addEventListener('focusin', () => this.stopAutoplay(), { signal });
    this.addEventListener('focusout', () => this.startAutoplay(), { signal });

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.listeners?.abort();
    this.stopAutoplay();
  }

  startAutoplay() {
    if (this.reduceMotion || this.buttons.length < 2 || this.timer || this.matches(':hover, :focus-within')) return;

    this.timer = window.setInterval(() => {
      const nextIndex = (this.index + 1) % this.buttons.length;
      this.select(this.buttons[nextIndex].dataset.brandSwitchButton, false);
    }, 2000);
  }

  stopAutoplay() {
    if (!this.timer) return;

    window.clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  select(index, shouldFocus = true) {
    this.index = this.buttons.findIndex((button) => button.dataset.brandSwitchButton === String(index));

    this.buttons.forEach((button) => {
      const isActive = button.dataset.brandSwitchButton === index;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.dataset.active = String(isActive);
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.brandSwitchPanel === index;
      panel.hidden = false;
      panel.dataset.active = String(isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    if (shouldFocus) {
      this.dispatchEvent(new CustomEvent('brand-switch', { detail: { index }, bubbles: true }));
    }
  }
}

if (!customElements.get('storefront-brand-switcher')) {
  customElements.define('storefront-brand-switcher', StorefrontBrandSwitcher);
}
